var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"w-full z-20 border-b border-orange bg-white",attrs:{"height":"100px","max-height":"100","flat":""}},[_c('v-container',[_c('GiddyUpWordmark',{staticClass:"gu__icon"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }